import { useSelector } from "react-redux"
import { customToast } from "../../../components/Toast"
import Send from "../../communication"
import { useScope } from "../../../container/SelectProjectCompanyContainer"
import { useQuery } from "@tanstack/react-query"
import moment from "moment"
import { sort } from "fast-sort"
import { useUsers } from "./useUsers"
import { timestampToHumanReadable } from "../timestampToHumanReadable"

export const getDwContentData = async (question, formId, projectId) => {
  const { scopeType } = useScope();

  let dwContentData = []
  
  let extraProps = ""
    if (question) {
      extraProps += `&questions='${question}'`
    }

    if (formId) {
      extraProps += `&forms='${formId}'`
    }

    const dw = Send.get("/dw/data/content", `projects='${projectId}'${extraProps}&scopeType=${scopeType}`)

    await Promise.all([dw])
      .then(([dw]) => {
        if (dw.length > 0) {
          dwContentData = dw
        } else {
          customToast("Não há dados para gerar gráficos ou tabelas!", "warning")
        }
      })
      .catch((e) => {
        dwContentData = []
      })

  return dwContentData
}

const pivot = (arr) => {
  var o = arr.reduce((a, b) => {
    a[b.ID] = a[b.ID] || []
    a[b.ID].push({ [b.Pergunta_codigo]: b.Resposta })
    return a
  }, {})

  var a = Object.keys(o).map(function (k) {
    const data = { ...arr.find((item) => item.ID === k) }

    delete data.Resposta
    delete data.Pergunta_codigo

    return {
      ...data,
      realInicio: data.Inicio?.value,
      Inicio: moment(data.Inicio?.value).format("DD/MM/YYYY"),
      Pergunta_codigo: Object.assign.apply({}, o[k]),
    }
  })

  return sort(a).desc("realInicio")
}

export const useLoadDataDwContent = () => {
  const { scope, scopeType } = useScope()
  const {users, tags, tagsProject, reload: reloadUsers } = useUsers()
  

  const loadDataDwcontent = async () => {
    const dw = await Send.get("/dw/content", `projects='${scope?.id}'&scopeType=${scopeType}`)
  
    const output = pivot(
        dw.map((item) => ({
        ...item,
        tag_user: users
          .filter((user) => user && user.id === item.ID)
          .map((a) => a.tag_user)
          .flat(),
      })),
    )

    return output
  }

  const { data, isLoading, isFetched, isFetching, isError, isStale, refetch, dataUpdatedAt } = useQuery(
    ["users-dw", scope?.id, users, tags],
    loadDataDwcontent,
    {
    staleTime: 120000,
    refetchInterval: 60000,
    cacheTime: 60000
    },
  )

  const lastUpdated = timestampToHumanReadable(dataUpdatedAt)

  const reload = () => {
    refetch()
  }

  return {
    dw: data || [],
    tag: tags,
    tagsProject,
    isLoading,
    isFetched,
    isFetching,
    isError,
    isStale,
    reload,
    lastUpdated
  }
}
